import React, { useState, useMemo } from "react";
import html2canvas from "html2canvas";
import { jsPDF } from "jspdf";
import "jspdf/dist/polyfills.es.js";
import EditableField from "./EditableField";

const useHover = () => {
  const [hovered, setHovered] = useState();

  const eventHandlers = useMemo(
    () => ({
      onMouseOver() {
        setHovered(true);
      },
      onMouseOut() {
        setHovered(false);
      },
    }),
    []
  );
  return [hovered, eventHandlers];
};

const DesignCv = (props) => {
  const [cv, setCV] = useState({
    name: {
      default: "Full Name",
      value: "KIRIL NIKOLOVSKI",
    },
    title: {
      default: "Proffesional Title",
      value: "GRAPHIC DESIGNER",
    },
    about: {
      default: "About Me",
      value:
        "Graphic Designer with expertise in branding and logo design,packing design,typography,creative direction and ilustration.Oriented into helping small businesses realize their unique vision.",
    },
    workExpereince: {
      default: "Work",
      value: "WORK EXPERIENCE",
    },
    expereince: {
      default: "Experience",
      value: "02.2019 - ",
    },
    company: {
      default: "Company",
      value: "Brainster.co. Skopje.",
    },
    position: {
      default: "Position",
      value: "Junior Graphic Designer",
    },
    aboutMe: {
      default: "aboutMe",
      value:
        "Creating visual concepts to communicate ideas that inspire,inform and captiviate consumers.Developing overall layout and production design for ads,brochures,magazines and corporate marketing content",
    },
    education: {
      default: "Education",
      value: "EDUCATION",
    },
    year: {
      default: "xxx",
      value: "2018-2019",
    },
    company1: {
      default: "Company",
      value: "Brainster Academy of Design",
    },
    year1: {
      default: "xxx",
      value: "2016-2019",
    },
    education1: {
      default: "Education",
      value:
        "SS.Cyril and Methodius University Faculti of Mechanical Engineering Industrial Design.",
    },

    thirdTitle: {
      default: "YEAR",
      value: "2016-2019",
    },
    thirdWork: {
      default: "WORK",
      value: "Upwork",
    },
    thirdCompany: {
      default: "Company",
      value: "Freelance Graphic Designer",
    },
    thirdAbout: {
      default: "About Job",
      value:
        "Working with international clients and helping them get their ideas out in a workable way.Conceptualizing visuals based on their requirements.Shaping the visual aspects of brand identilies product packing,book covers,magazines,brochures,posters,and many more.",
    },
    fourthTitle: {
      default: "Skills",
      value: "SKILLS",
    },
    fourthSkill: {
      default: "Skill",
      value: "Adobe Photoshop",
    },
    fourthSkill1: {
      default: "Skill1",
      value: "Adobe Ilustrator",
    },
    fourthSkill2: {
      default: "Skill2",
      value: "Adobe InDesign",
    },
    fourthSkill3: {
      default: "Skill3",
      value: "Adobe Premiere Pro",
    },
    fourthSkill4: {
      default: "Skill4",
      value: "Adobe After Effects",
    },
    fourthSkill5: {
      default: "Skill5",
      value: "Adobe Xd",
    },
    fourthSkill6: {
      default: "Skill6",
      value: "MS Office",
    },
    fourthSkill7: {
      default: "Skill7",
      value: "Solid Works",
    },
    fifthTitle: {
      default: "Contact",
      value: "CONTACT",
    },
    fifthPara: {
      default: "xxxxxx",
      value: "xxxxx",
    },
    fifthPara1: {
      default: "e-mail",
      value: "kiril.nikolovski@gmail.com",
    },
    fifthPara2: {
      default: "linkedin",
      value: "linkedin.com/in/kiril-nikolovski",
    },
    fifthPara3: {
      default: "PLace",
      value: "Skopje,Macedonia",
    },
  });

  const downloadPDF = () => {
    const page = document.getElementById("doctopdf");
    page.style.marginTop = "-" + page.offsetHeight * 1.31 + "px";
    html2canvas(page).then((canvas) => {
      const imgData = canvas.toDataURL("image/png");
      const pdf = new jsPDF();
      pdf.addImage(imgData, "JPEG", 0, 0);
      pdf.save("design.pdf");
      props.handleShow(true);
    });
  };

  return (
    <div id="doctopdf">
      <div className="Design  marginDesign">
        <div className="row">
          <div className="col-md-6 ">
            <div className="designBox p-3">
              <h3 className="font-weight-bold mt-5">
                <EditableField
                  cv={cv}
                  setCV={setCV}
                  field="name"
                  editMode={props.editMode}
                  handleHover={props.handleHover}
                />
              </h3>
              <h5 className="font-weight-bold">
                <EditableField
                  cv={cv}
                  setCV={setCV}
                  field="title"
                  editMode={props.editMode}
                  handleHover={props.handleHover}
                />
              </h5>
            </div>
          </div>
        </div>
        <div className="row p-4">
          <div className="col-md-6">
            <div>
              <EditableField
                cv={cv}
                setCV={setCV}
                field="about"
                editMode={props.editMode}
                handleHover={props.handleHover}
              />
            </div>
          </div>
        </div>

        <div className="row p-4">
          <div className="col-md-6 ">
            <h4 className="m-0">
              <EditableField
                cv={cv}
                setCV={setCV}
                field="workExpereince"
                editMode={props.editMode}
                handleHover={props.handleHover}
              />
            </h4>
            <div className="text-info">
              <EditableField
                cv={cv}
                setCV={setCV}
                field="expereince"
                editMode={props.editMode}
                handleHover={props.handleHover}
              />
            </div>
            <div className="CVPARA">
              <EditableField
                cv={cv}
                setCV={setCV}
                field="company"
                editMode={props.editMode}
                handleHover={props.handleHover}
              />
            </div>
            <div className="CVPARA">
              <EditableField
                cv={cv}
                setCV={setCV}
                field="position"
                editMode={props.editMode}
                handleHover={props.handleHover}
              />
            </div>
            <div className="CVPARA">
              <EditableField
                cv={cv}
                setCV={setCV}
                field="aboutMe"
                editMode={props.editMode}
                handleHover={props.handleHover}
              />
            </div>
          </div>
          <div className="col-md-6 ">
            <h4 className="m-0">
              <EditableField
                cv={cv}
                setCV={setCV}
                field="education"
                editMode={props.editMode}
                handleHover={props.handleHover}
              />
            </h4>
            <div className="text-info m-0">
              <EditableField
                cv={cv}
                setCV={setCV}
                field="year"
                editMode={props.editMode}
                handleHover={props.handleHover}
              />
            </div>
            <div className="CVPARA ">
              <EditableField
                cv={cv}
                setCV={setCV}
                field="company1"
                editMode={props.editMode}
                handleHover={props.handleHover}
              />
            </div>
            <div className="CVPARA mt-5 mb-0">
              <EditableField
                cv={cv}
                setCV={setCV}
                field="year1"
                editMode={props.editMode}
                handleHover={props.handleHover}
              />
            </div>
            <div className="CVPARA">
              <EditableField
                cv={cv}
                setCV={setCV}
                field="education1"
                editMode={props.editMode}
                handleHover={props.handleHover}
              />
            </div>
          </div>
        </div>
        <div className="row p-4">
          <div className="col-md-6 ">
            <h4 className="m-0">
              <EditableField
                cv={cv}
                setCV={setCV}
                field="thirdTitle"
                editMode={props.editMode}
                handleHover={props.handleHover}
              />
            </h4>
            <div className="m-0">
              <EditableField
                cv={cv}
                setCV={setCV}
                field="thirdWork"
                editMode={props.editMode}
                handleHover={props.handleHover}
              />
            </div>
            <div className="CVPARA m-0">
              <EditableField
                cv={cv}
                setCV={setCV}
                field="thirdCompany"
                editMode={props.editMode}
                handleHover={props.handleHover}
              />
            </div>
            <div className="CVPARA">
              <EditableField
                cv={cv}
                setCV={setCV}
                field="thirdAbout"
                editMode={props.editMode}
                handleHover={props.handleHover}
              />
            </div>
          </div>
          <div className="col-md-6 ">
            <h4>
              <EditableField
                cv={cv}
                setCV={setCV}
                field="fourthTitle"
                editMode={props.editMode}
                handleHover={props.handleHover}
              />
            </h4>
            <div className="CVPARA m-0">
              <EditableField
                cv={cv}
                setCV={setCV}
                field="fourthSkill"
                editMode={props.editMode}
                handleHover={props.handleHover}
              />
            </div>
            <div className="CVPARA m-0">
              <EditableField
                cv={cv}
                setCV={setCV}
                field="fourthSkill1"
                editMode={props.editMode}
                handleHover={props.handleHover}
              />
            </div>
            <div className="CVPARA m-0">
              <EditableField
                cv={cv}
                setCV={setCV}
                field="fourthSkill2"
                editMode={props.editMode}
                handleHover={props.handleHover}
              />
            </div>
            <div className="CVPARA m-0">
              <EditableField
                cv={cv}
                setCV={setCV}
                field="fourthSkill3"
                editMode={props.editMode}
                handleHover={props.handleHover}
              />
            </div>
            <div className="CVPARA m-0">
              <EditableField
                cv={cv}
                setCV={setCV}
                field="fourthSkill4"
                editMode={props.editMode}
                handleHover={props.handleHover}
              />
            </div>
            <div className="CVPARA m-0">
              <EditableField
                cv={cv}
                setCV={setCV}
                field="fourthSkill5"
                editMode={props.editMode}
                handleHover={props.handleHover}
              />
            </div>
            <div className="CVPARA m-0">
              <EditableField
                cv={cv}
                setCV={setCV}
                field="fourthSkill6"
                editMode={props.editMode}
                handleHover={props.handleHover}
              />
            </div>
            <div className="CVPARA m-0">
              <EditableField
                cv={cv}
                setCV={setCV}
                field="fourthSkill7"
                editMode={props.editMode}
                handleHover={props.handleHover}
              />
            </div>
          </div>
        </div>

        <div className="row p-4 mb-4">
          <div className="col-md-6 ">
            <h4 className="m-0">
              <EditableField
                cv={cv}
                setCV={setCV}
                field="fifthTitle"
                editMode={props.editMode}
                handleHover={props.handleHover}
              />
            </h4>
            <div className="m-0">
              <EditableField
                cv={cv}
                setCV={setCV}
                field="fifthPara"
                editMode={props.editMode}
                handleHover={props.handleHover}
              />
            </div>
            <div className="CVPARA m-0">
              <EditableField
                cv={cv}
                setCV={setCV}
                field="fifthPara1"
                editMode={props.editMode}
                handleHover={props.handleHover}
              />
            </div>
            <div className="CVPARA m-0">
              <EditableField
                cv={cv}
                setCV={setCV}
                field="fifthPara2"
                editMode={props.editMode}
                handleHover={props.handleHover}
              />
            </div>
            <div className="CVPARA m-0">
              <EditableField
                cv={cv}
                setCV={setCV}
                field="fifthPara3"
                editMode={props.editMode}
                handleHover={props.handleHover}
              />
            </div>
          </div>
        </div>

        <div className="row mb-5">
          <div className="col-md-12 text-right innerInput">
            <button
              className="btn text-right buttonHome"
              data-html2canvas-ignore="true"
              onClick={downloadPDF}
            >
              DOWNLOAD
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DesignCv;
